/**
 * The paper's own metadata, one source for the web page (title, byline, metadata, JSON-LD,
 * catalog, homepage card, announcement bar, via publish-status.ts and content.ts) and the PDF
 * (cover, document properties, via print/). The text is in ./whitepaper/a-model-of-the-ai-native-sdlc.md;
 * the parts' names are the `part` of each part's first chapter under `chapters:` in its frontmatter.
 * Copy only the PDF prints (part leads, cover and back cover lines) is in print/paper-print.ts, so
 * client bundles don't take it.
 *
 * Plain data, no imports: client bundles take it, and `node scripts/whitepaper-pdf/build.ts`
 * runs it with Node's type stripping.
 */

const AUTHOR_JOB_TITLE = 'Founder and CEO';

export const PAPER = {
  title: 'A Model of the AI-Native SDLC',
  /** The PDF cover's subtitle. */
  subtitle: 'Rebuilding Delivery to Keep Pace with Coding Agents',
  author: 'Hans Dockter',
  /** JSON-LD jobTitle (with worksFor the Organization). */
  authorJobTitle: AUTHOR_JOB_TITLE,
  /** The byline: the PDF cover's and the page's Author row. */
  authorRole: `${AUTHOR_JOB_TITLE}, Develocity`,
  /** The publish month readers see: the PDF cover's date, the page's "Published" row, the homepage card. */
  date: 'October 2026',
} as const;
